import Vue from 'vue';
import { numberFormat, numFormat2 } from "@/assets/js/mUtils";

// numberFormat 保留小数位  过滤器
Vue.filter('numberFormat', (v) => numberFormat(v));

// 不保留2位过滤器
Vue.filter('numFormat2', (v) => numFormat2(v));

// 注册 formatMoney 过滤器
Vue.filter('formatMoney', function(val) {
    // 边界防御：处理 null, undefined, 空字符串
    if (val === null || val === undefined || val === '') {
        return '';
    }
    const num = parseFloat(val);

    // 如果转换结果不是数字（比如传入了 "abc"），原样返回
    if (isNaN(num)) {
        return val;
    }
    // 核心转换逻辑
    return numFormat2(num);
});
